import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, Button, message } from 'antd';

import MUTATION from '../graphql/mutations/storeCustomerBankAccountMutation.graphql';
import STORE_QUERY from '../graphql/queries/getCustomerBankAccountsQuery.graphql';

const FormItem = Form.Item;

const labelColXsSpan = 4;
const formItemLayout = {
  labelCol: {
    xs: { span: labelColXsSpan },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: labelColXsSpan,
    },
  },
};

class BankAccountForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const { customer_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { customer_id, ...values },
          update: (cache, { data: { newCustomerBankAccount } }) => {
            const data = cache.readQuery({
              query: STORE_QUERY,
              variables: { customer_id },
            });
            if (!Array.isArray(data.customerBankAccounts)) data.customerBankAccounts = [];
            data.customerBankAccounts.push(newCustomerBankAccount);
            cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="Bank Name"
        >
          {
            getFieldDecorator(
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Bank name is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="A/c no."
        >
          {
            getFieldDecorator(
              'ac_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'A/c no. is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" size="small" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

BankAccountForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(BankAccountForm);



// WEBPACK FOOTER //
// ./src/forms/BankAccountForm.jsx